export default __webpack_public_path__ + "static/media/kyle.75f27be3.png";